import React from 'react';
import {
  Row,
  Col,
  Button,
  ModalHeader,
  ModalBody,
  Modal,
  ModalFooter,
  Label,
  Container,
} from 'reactstrap';
import { Formik } from 'formik';
import DynamicFormikField from '../../../components/forms/DynamicFormikField';
import TinySpinner from '../../../components/TinySpinner';
import {
  FieldConfigs,
  DoubleFactorAuthEnabledConfiguration,
} from './UpdateProfileFields';
import useUpdateProfileForm from './useUpdateProfileForm';
import FileUploadFormItem from '../../../components/forms/FileUploadFormItem';
import CardLoader from '../../../components/loaders/CardLoader';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  boxContainer: {
    border: '1px solid lightgray',
    padding: '20px',
    marging: '1px',
    marginBottom: '20px',
    animation: 'animate-grow-container 850ms forwards',
  },
});

const UpdateProfile = React.memo(function UpdateProfile({
  isOpen,
  setIsOpen,
  ...props
}) {
  const classes = useStyles();
  const { formikOptions, initialised } = useUpdateProfileForm({
    ...props,
    setIsOpen,
  });
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
  } = formikOptions;

  return (
    <Modal isOpen={isOpen}>
      <Formik {...formikOptions}>
        <form onSubmit={handleSubmit}>
          <ModalHeader className="border-bottom-0">Update Profile</ModalHeader>
          <ModalBody>
            <div className="container-content">
              <Row className="">
                <Col>
                  {!initialised ? (
                    <CardLoader />
                  ) : (
                    <React.Fragment>
                      <Row className="margin-bottom-10" form>
                        <Col>
                          <Label>Profile Picture</Label>
                          <FileUploadFormItem
                            name="profilePictureFile"
                            setFieldValue={setFieldValue}
                            value={values.profilePictureFile}
                            accept={{ 'image/*': ['.png', '.jpg', '.jpeg'] }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        {FieldConfigs.map((fieldConfig, configIndex) => (
                          <Col
                            md={fieldConfig.colSpan || 12}
                            key={`form-field-key-${configIndex}`}
                          >
                            <DynamicFormikField
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              values={values}
                              touched={touched}
                              errors={errors}
                              setFieldValue={setFieldValue}
                              fieldConfig={fieldConfig}
                            />
                          </Col>
                        ))}
                      </Row>

                      <Row className={classes.boxContainer}>
                        <Col md={12}>
                          <span>
                            Two-step verification options add an extra layer of
                            security to block unauthorized access and protect
                            your account.
                          </span>
                        </Col>
                        {DoubleFactorAuthEnabledConfiguration.map(
                          (fieldConfig, configIndex) => (
                            <Col
                              md={fieldConfig.colSpan || 12}
                              key={`form-field-key-${configIndex}`}
                            >
                              <DynamicFormikField
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                values={values}
                                touched={touched}
                                errors={errors}
                                setFieldValue={setFieldValue}
                                fieldConfig={fieldConfig}
                              />
                            </Col>
                          ),
                        )}
                      </Row>
                    </React.Fragment>
                  )}
                </Col>
              </Row>
            </div>
          </ModalBody>
          <ModalFooter className="border-top-0">
            <Container>
              <Row>
                {initialised && (
                  <React.Fragment>
                    <Col>
                      <Button
                        color="primary"
                        className="w-100"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {!isSubmitting && <span>Submit</span>}
                        {isSubmitting && (
                          <span>
                            Submitting
                            <TinySpinner />
                          </span>
                        )}
                      </Button>
                    </Col>
                    <Col xs={6}>
                      <Button
                        className="w-100"
                        color="secondary"
                        onClick={() => {
                          setIsOpen(false);
                        }}
                      >
                        Close
                      </Button>
                    </Col>
                  </React.Fragment>
                )}
              </Row>
            </Container>
          </ModalFooter>
        </form>
      </Formik>
    </Modal>
  );
});

export default UpdateProfile;
